import $store from 'domovio-core/src/system/store';

import ProjectsModule from '../modules/ProjectModule/store/projects.module';

/**
 * @return {void}
 */
export const registerStoreModules = () => {
    $store.registerModule('projects', ProjectsModule);
}
